import { useTranslation } from 'next-i18next'

import TopicCard from '~/statistics-v2/components/TopicCard'
import { TopicsOverviewProps } from '~/statistics-v2/types/statistics.types'

export default function TopicsOverview({
  combinedTopics,
  onSelectTopic,
  hideMustKnows,
}: TopicsOverviewProps): React.ReactElement {
  const { t } = useTranslation('statisticsV2')
  return (
    <div className="flex flex-col justify-between w-87.5 lg:w-full">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col px-2 gap-3">
          <h2 className="text-white text-2xl lg:text-3xl font-black">{t('topicsAndProgress')}</h2>
          <p className="text-purple-pastel text-xs lg:text-sm">{t('clickOnTopic')}</p>
        </div>
        <div className="flex flex-wrap justify-between gap-4 items-stretch w-full">
          {combinedTopics.map((topic) => (
            <div className="flex" key={topic.topicId}>
              <TopicCard hideMustKnows={hideMustKnows} onTopicSelect={onSelectTopic} topic={topic} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
